class ApplicationForm {
    constructor() {
        this.dot = '.';
        // add global class identifier
        this.class = {
            checkfield: '.checkinput',
            hidden: '.hidden',
            data: {},
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * initialize functions
     */
    init() {
        const checkProperties = document.querySelectorAll(this.class.checkfield);
        if (checkProperties.length > 0) {
            checkProperties.forEach((checkproperty) => {
                checkproperty.checkData = checkproperty.dataset;
                if (checkproperty.checkData.checkevent !== undefined) {
                    this.checkall(checkproperty);
                    checkproperty.addEventListener(checkproperty.checkData.checkevent, (evnt) => {
                        if (checkproperty.checkData.ckeckvalue !== undefined
                            && checkproperty.checkData.checkwhitch !== undefined
                        ) {
                            const selectorAll = this.dot + checkproperty.checkData.checkwhitch;
                            const targetProperties = document.querySelectorAll(selectorAll);
                            if (targetProperties !== undefined && targetProperties.length > 0) {
                                targetProperties.forEach((targetProperty) => {
                                    this.checkall(checkproperty, targetProperty, evnt);
                                });
                            }
                        }
                    });
                }
            });
        }
    }

    checkall(checkproperty, property, evnt) {
        if (checkproperty !== undefined) {
            switch (checkproperty.checkData.checktype) {
            case 'hs':
                this.checkHideFields(checkproperty, property, evnt);
                break;
            case 'tl':
                ApplicationForm.checkTextCount(checkproperty, property);
                break;
            case 'co':
                ApplicationForm.changeOptionValues(checkproperty, property, evnt);
                break;
            case 'na':
                ApplicationForm.checkNotAllowedValue(checkproperty, property, evnt);
                break;
            default:
            }
        }
    }

    static checkNotAllowedValue(checkproperty, property, evnt) {
        if (property !== undefined && evnt !== undefined) {
            let propertyValue = '';

            switch (property.tagName) {
            case 'SELECT':
                propertyValue = property.value;
                break;
            default:
            }
            if (propertyValue !== undefined
                && checkproperty.checkData.ckeckvalue !== undefined
                && propertyValue === checkproperty.checkData.ckeckvalue
            ) {
                if (checkproperty.checkData.checkalerttext !== undefined) {
                    alert(checkproperty.checkData.checkalerttext); // eslint-disable-line no-alert
                }
            }
        }
    }

    static changeOptionValues(checkproperty, property, evnt) {
        if (property === undefined && evnt === undefined) {
            const selector = checkproperty.checkData.checkwhitch;
            const property = document.getElementsByClassName(selector)[0];
            const selectedValue = property.value;
            ApplicationForm.removeAllOptions(property);
            if (checkproperty.value === '') {
                ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextnooption });
            } else {
                const data = JSON.parse(checkproperty.checkData.checkdatajson);
                ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextoption });
                ApplicationForm.addOption(property, data[checkproperty.value], selectedValue);
            }
        } else if (evnt !== undefined) {
            if (checkproperty.checkData.checkdatajson !== undefined
                && ApplicationForm.isJsonString(checkproperty.checkData.checkdatajson)
            ) {
                const data = JSON.parse(checkproperty.checkData.checkdatajson);
                ApplicationForm.removeAllOptions(property);
                if (checkproperty.value === '') {
                    ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextnooption });
                } else {
                    ApplicationForm.addOption(property, { '': checkproperty.checkData.checkstarttextoption });
                }
                ApplicationForm.addOption(property, data[evnt.target.value]);
            }
        }
    }

    static addOption(select, options, selectedValue) {
        if (options !== undefined) {
            const entries = Object.entries(options);
            const optionsCount = select.options.length;
            entries.forEach((element, key) => {
                const selected = element[0] === selectedValue;
                select[key + optionsCount] = new Option(element[1], element[0], false, selected);
            });
        }
    }

    static removeAllOptions(select) {
        const L = select.options.length - 1;
        for (let i = L; i >= 0; i -= 1) {
            select.remove(i);
        }
    }

    static isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    static checkTextCount(checkproperty, property) {
        const remainingTextLength = checkproperty.checkData.ckeckvalue - checkproperty.value.length;
        if (property === undefined) {
            const selector = checkproperty.checkData.checkwhitch;
            property = document.getElementsByClassName(selector);
        }
        property.innerHTML = remainingTextLength;
    }

    checkHideFields(checkproperty, property, evnt) {
        if (property === undefined && evnt === undefined) {
            const selectorAll = this.dot + checkproperty.checkData.checkwhitch;
            const hideFields = document.querySelectorAll(selectorAll);
            if (hideFields.length > 0) {
                hideFields.forEach((field) => {
                    if (field.classList.contains('hidden')) {
                        ApplicationForm.hideShowField(checkproperty.value, checkproperty, field);
                    }
                });
            }
        } else {
            ApplicationForm.hideShowField(evnt.target.value, checkproperty, property);
        }
    }

    static hideShowField(value, cmp, property) {
        if (cmp.checkData.ckeckvalue !== '') {
            if (value === cmp.checkData.ckeckvalue) {
                property.style.setProperty('display', 'block', 'important');
            } else {
                const resetFields = document.querySelectorAll(`.${cmp.checkData.checkwhitch} input`);
                if (resetFields.length > 0) {
                    resetFields.forEach((field) => {
                        field.value = '';
                    });
                }
                property.style.display = 'none';
            }
        } else if (cmp.checkData.ckeckvalue === '') {
            if (value !== cmp.checkData.ckeckvalue) {
                property.style.setProperty('display', 'block', 'important');
            } else {
                const resetFields = document.querySelectorAll(`.${cmp.checkData.checkwhitch} input`);
                if (resetFields.length > 0) {
                    resetFields.forEach((field) => {
                        field.value = '';
                    });
                }
                property.style.display = 'none';
            }
        }
    }
}

export default new ApplicationForm();
